import { relayStylePagination } from '@apollo/client/utilities';

export default {
  AlphaPostActivity: {
    fields: {
      actors: { merge: false },
    },
  },
  AlphaTopicActivity: {
    fields: {
      actors: { merge: false },
    },
  },
  Comment: {
    fields: {
      reactions: { merge: false },
    },
  },
  CommentFields: {
    fields: {
      reactions: { merge: false },
    },
  },
  CommentThread: {
    fields: {
      comments: { merge: false },
    },
  },
  CreateTestOrganizationResult: {
    fields: {
      testUsers: { merge: false },
    },
  },
  CurrentUser: {
    fields: {
      sections: { merge: false },
    },
  },
  ExternalPostPlatform: {
    fields: {
      posts: relayStylePagination(),
    },
  },
  ExternalSearchPlatform: {
    fields: {
      installModes: { merge: false },
    },
  },
  Group: {
    fields: {
      allUsers: { merge: false },
      children: { merge: false },
      members: { merge: false },
      membershipTopics: { merge: false },
      owners: { merge: false },
      parents: { merge: false },
      requestors: { merge: false },
    },
  },
  History: {
    fields: {
      alphaEditors: { merge: false },
      annotations: { merge: false },
      authors: { merge: false },
      threads: { merge: false },
    },
  },
  InsightMetrics: {
    fields: {
      metrics: { merge: false },
    },
  },
  IntegrationSettings: {
    fields: {
      enabledParents: { merge: false },
      enabledSearchSources: { merge: false },
      syncingRepos: { merge: false },
    },
  },
  Mention: {
    fields: {
      breadcrumbs: { merge: false },
      participants: { merge: false },
      tags: { merge: false },
    },
  },
  MentionContentHighlights: {
    fields: {
      highlights: { merge: false },
    },
  },
  Mutation: {
    fields: {
      alphaDeleteHistories: { merge: false },
      applyProvision: { merge: false },
      importFiles: { merge: false },
      markNotifications: { merge: false },
      notificationSetRead: { merge: false },
      reorderTopics: { merge: false },
    },
  },
  NotificationStatusIds: {
    fields: {
      ids: { merge: false },
    },
  },
  Organization: {
    fields: {
      auditLogs: relayStylePagination(),
      customDomains: { merge: false },
      groups: { merge: false },
      integrations: { merge: false },
      invitations: { merge: false },
      notifications: relayStylePagination(),
      posts: { merge: false },
      provisions: { merge: false },
      sections: { merge: false },
      series: { merge: false },
      topics: { merge: false },
      unreadNotifications: relayStylePagination(),
      users: { merge: false },
      webhooks: { merge: false },
    },
  },
  OrganizationSettings: {
    fields: {
      allowedEmbedHosts: { merge: false },
    },
  },
  OrganizationSettingsPublic: {
    fields: {
      links: { merge: false },
      sectionIds: { merge: false },
    },
  },
  Post: {
    fields: {
      annotations: { merge: false },
      backlinks: { merge: false },
      contributions: { merge: false },
      contributors: { merge: false },
      histories: { merge: false },
      thankers: { merge: false },
      thanks: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
      verificationEntries: { merge: false },
      viewers: { merge: false },
    },
  },
  PostDirectShare: {
    fields: {
      draftLinkEditorIds: { merge: false },
      editorGroupIds: { merge: false },
      editorIds: { merge: false },
      viewerGroupIds: { merge: false },
      viewerIds: { merge: false },
    },
  },
  PostFields: {
    fields: {
      annotations: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
    },
  },
  PostInsights: {
    fields: {
      edits: { merge: false },
      metrics: { merge: false },
      reads: { merge: false },
    },
  },
  PostSearchResult: {
    fields: {
      ancestors: { merge: false },
    },
  },
  Provision: {
    fields: {
      favoritePosts: { merge: false },
      favoriteTopics: { merge: false },
      groups: { merge: false },
      posts: { merge: false },
      topics: { merge: false },
    },
  },
  PublicComment: {
    fields: {
      reactions: { merge: false },
    },
  },
  PublicCommentThread: {
    fields: {
      comments: { merge: false },
    },
  },
  PublicOrganization: {
    fields: {
      sections: { merge: false },
      ssoPlatforms: { merge: false },
    },
  },
  PublicOrganizationSettings: {
    fields: {
      allowedEmbedHosts: { merge: false },
    },
  },
  PublicPost: {
    fields: {
      annotations: { merge: false },
      threads: { merge: false },
      topics: { merge: false },
    },
  },
  PublicReactionThread: {
    fields: {
      reactions: { merge: false },
    },
  },
  PublicSearchResultConnection: {
    fields: {
      ancestorIds: { merge: false },
    },
  },
  PublicSection: {
    fields: {
      items: { merge: false },
    },
  },
  PublicSeries: {
    fields: {
      posts: { merge: false },
    },
  },
  PublicTopic: {
    fields: {
      ancestors: { merge: false },
      descendants: relayStylePagination(),
      pinnedPostIds: { merge: false },
      posts: { merge: false },
    },
  },
  Query: {
    fields: {
      activities: relayStylePagination(),
      aiKeywords: { merge: false },
      alphaPostActivities: { merge: false },
      alphaTopicActivities: { merge: false },
      externalPostPlatforms: { merge: false },
      externalSearch: { merge: false },
      externalSearchPlatforms: { merge: false },
      externalSearchSources: { merge: false },
      gitRepos: { merge: false },
      insightLeaderboard: relayStylePagination(),
      insightTopPosts: relayStylePagination(),
      insightTopSearches: relayStylePagination(),
      mentionParents: { merge: false },
      posts: { merge: false },
      publicPosts: { merge: false },
      publicSearch: relayStylePagination(),
      publicTopics: { merge: false },
      search: relayStylePagination(),
      searchTypes: { merge: false },
      topics: { merge: false },
      unorganized: relayStylePagination(),
    },
  },
  ReactionThread: {
    fields: {
      reactions: { merge: false },
    },
  },
  RootPostFields: {
    fields: {
      topics: { merge: false },
    },
  },
  Section: {
    fields: {
      items: { merge: false },
    },
  },
  Series: {
    fields: {
      posts: { merge: false },
    },
  },
  SeriesFields: {
    fields: {
      posts: { merge: false },
    },
  },
  SlimHistory: {
    fields: {
      alphaEditors: { merge: false },
      authors: { merge: false },
    },
  },
  SlimHistoryFields: {
    fields: {
      alphaEditors: { merge: false },
      authors: { merge: false },
    },
  },
  SlimPost: {
    fields: {
      contributors: { merge: false },
      topics: { merge: false },
    },
  },
  SlimPostFields: {
    fields: {
      contributors: { merge: false },
      topics: { merge: false },
    },
  },
  Subscription: {
    fields: {
      notificationsNew: { merge: false },
      notificationsStatusUpdated: { merge: false },
      notificationsUpdated: { merge: false },
    },
  },
  Topic: {
    fields: {
      activities: relayStylePagination(),
      ancestors: { merge: false },
      children: { merge: false },
      contributors: { merge: false },
      descendants: relayStylePagination(),
      inheritedAncestors: { merge: false },
      memberGroups: { merge: false },
      members: { merge: false },
      ownerGroups: { merge: false },
      owners: { merge: false },
      pinnedPostIds: { merge: false },
      postCounts: { merge: false },
      posts: relayStylePagination(),
      requestors: { merge: false },
    },
  },
  TopicFields: {
    fields: {
      ancestors: { merge: false },
    },
  },
  TopicMembership: {
    fields: {
      memberGroupIds: { merge: false },
      memberUserIds: { merge: false },
      ownerGroupIds: { merge: false },
      ownerUserIds: { merge: false },
      requestorUserIds: { merge: false },
    },
  },
  TopicSearchResult: {
    fields: {
      ancestors: { merge: false },
    },
  },
  User: {
    fields: {
      drafts: relayStylePagination(),
      identities: { merge: false },
      membershipGroups: { merge: false },
      membershipTopics: { merge: false },
      posts: relayStylePagination(),
      viewedPosts: relayStylePagination(),
    },
  },
  UserSidebarSettings: {
    fields: {
      myTopicIds: { merge: false },
      sectionIds: { merge: false },
    },
  },
  Verification: {
    fields: {
      secondaryVerifiers: { merge: false },
    },
  },
  Webhook: {
    fields: {
      events: { merge: false },
      topics: { merge: false },
    },
  },
};
